import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRODUCT_PROMOTIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createProductPromotionsAction = createAsyncThunk(
    'price/createProductPromotionsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ PRODUCT_PROMOTIONS_PATH }/product/${ data.productId }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createProductPromotionsSlice = createSlice({
    name: 'createProductPromotionsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createProductPromotionsAction.pending, () => STATE__API__STARTED);
        builder.addCase(createProductPromotionsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createProductPromotionsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createProductPromotionsState = (state) => state.price.createProductPromotions;
export default createProductPromotionsSlice.reducer;
